import React from "react";
import { useExcursion } from "contexts/api";
import type { ExcursionSMSMessage } from "api/smsTemplates/SMSTemplate.typed";

export function useExcursionSmsHistory(excursionId: number | undefined, open: boolean) {
  const { listExcursionSMSMessages } = useExcursion();
  const [messages, setMessages] = React.useState<ExcursionSMSMessage[]>([]);
  const [total, setTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const requestRef = React.useRef(0);

  const refresh = React.useCallback(async () => {
    if (excursionId == null) return;
    requestRef.current += 1;
    const requestId = requestRef.current;
    setLoading(true);
    const res = await listExcursionSMSMessages(excursionId);
    if (requestId !== requestRef.current) return;
    setMessages(res?.messages ?? []);
    setTotal(res?.total ?? 0);
    setLoading(false);
  }, [excursionId, listExcursionSMSMessages]);

  React.useEffect(() => {
    if (open) void refresh();
  }, [open, refresh]);

  return { messages, total, loading, refresh };
}
